import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Breadcrumbs, Typography } from '@mui/material';

export const Title = ({ icon, title, breadcrumbs, buttons }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      {title && (
        <Box sx={{ height: '100%' }}>
          {/* Added back data-test-id for testing, needs to be identified by Locator.title() */}
          <Box data-test-id="title" sx={{ fontSize: '32px', fontWeight: 800 }}>
            {icon && (
              <FontAwesomeIcon icon={icon} style={{ marginRight: '10px' }} />
            )}
            {title}
          </Box>
          {breadcrumbs && (
            <Breadcrumbs
              separator={
                <FontAwesomeIcon icon={fas.faChevronRight} size="xs" />
              }
            >
              {breadcrumbs.map((breadcrumb) => (
                <Typography key={breadcrumb}>{breadcrumb}</Typography>
              ))}
            </Breadcrumbs>
          )}
        </Box>
      )}
      <Box
        sx={{
          marginLeft: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {/* Buttons set by parent component (Detail, List, etc.) */}
        {buttons}
      </Box>
    </Box>
  );
};
